import { CollectionProperty } from '@saga/shared/src/types';
import React from 'react';
import { Plus } from 'react-feather';
import { EditableHeaderInput } from './CollectionTable';
import Table from './Table';
import { InputDropdown, RenderItemProps } from '../popover/Dropdown';
import { PopOver } from '../popover/PopOver';
import { useTranslation } from 'react-i18next';
const OPTIONS: CollectionProperty['type'][] = ['string', 'singleSelect', 'multiSelect'];

function AddColumnHeader({
    onAddColumn,
}: {
    onAddColumn: (columnName: string, propertyType: CollectionProperty['type']) => void;
}) {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = React.useState(false);
    const [propertyType, setPropertyType] = React.useState<CollectionProperty['type'] | null>(null);

    const buttonRef = React.useRef<HTMLDivElement>(null);

    const handleAddClick = () => {
        setIsEditing(true);
    };

    React.useEffect(() => {
        if (!isEditing) {
            setPropertyType(null);
        }
    }, [isEditing]);

    return (
        <Table.Cell className="h-10 pb-3 align-middle min-w-12 w-12">
            {isEditing && propertyType ? (
                <EditableHeaderInput
                    label={''}
                    onLabelChange={(label) => {
                        onAddColumn(label, propertyType);
                        setIsEditing(false);
                    }}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <div className="flex items-center justify-end" ref={buttonRef}>
                    <button
                        onClick={handleAddClick}
                        className="flex items-center justify-center w-6 h-6 rounded hover:bg-saga-gray-200 dark:hover:bg-saga-gray-800 text-saga-gray-500"
                        aria-label="Add column"
                    >
                        <Plus size={16} />
                    </button>
                </div>
            )}

            <InputDropdown
                addTopPadding
                hideInput
                isOpen={isEditing && !propertyType}
                onClose={() => setIsEditing(false)}
                attachToRef={buttonRef}
                onSubmit={({ selectedItem }) => {
                    if (selectedItem) {
                        setPropertyType(selectedItem.type);
                    }
                }}
                renderItems={() =>
                    OPTIONS.map((option) => ({
                        item: {
                            title: option,
                            type: option,
                        },
                        render: ({ isSelected, setSelection, submit }: RenderItemProps) => (
                            <PopOver.RoundedButton
                                key={option}
                                onClick={submit}
                                selected={isSelected}
                                onMouseEnter={setSelection}
                            >
                                {t(`collections.properties.property_type_${option}`)}
                            </PopOver.RoundedButton>
                        ),
                    }))
                }
            />
        </Table.Cell>
    );
}

export default AddColumnHeader;
